import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { PageLoader } from '@/components/Spinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** admin 전용 (role === 'admin') */
  adminOnly?: boolean;
  /** toAccessAllFeatures 권한 필요 */
  requireAccessAllFeatures?: boolean;
}

export default function ProtectedRoute({
  children,
  adminOnly = false,
  requireAccessAllFeatures = false,
}: ProtectedRouteProps) {
  const location = useLocation();
  const currentUser = useAppSelector((s) => s.envs.currentUser);
  const isLoaded = useAppSelector((s) => s.envs.isLoaded);

  if (!isLoaded) {
    return <PageLoader />;
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && currentUser.role !== 'admin') {
    return <Navigate to="/campaigns" replace />;
  }

  if (requireAccessAllFeatures && !currentUser.permissions?.toAccessAllFeatures) {
    return <Navigate to="/campaigns" replace />;
  }

  return <>{children}</>;
}
